import { Component } from "react";
import { connect } from "react-redux";

import { PrimaryArrowButton } from "components/button/Button";
import { Input } from "components/input/Input";
import { Loader } from "components/loader/Loader";

class OfficeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterText: ""
    };
  }

  handleChange = (e) => {
    this.setState({
      filterText: e.target.value
    });
  };

  render() {
    return (
      <div>
        <div className={"d-flex justify-content-between mb-5"}>
          <h2 className={"m-0"}>Välj marknadsområde</h2>

          <div className="d-flex w-50 min-w-350" style={{ height: "3em" }}>
            <Input
              placeholder="Sök marknadsområde"
              size="sm"
              variant="rounded"
              onChange={this.handleChange}
              value={this.state.filterText}
            />
          </div>
        </div>
        <div className="table-wrapper">
          <table className="min-w-400">
            <thead>
              <tr>
                <td>
                  <label> Marknadsområde</label>
                </td>
                <td>
                  <label> Rapport skapad</label>
                </td>
                <td>
                  <label />
                </td>
              </tr>
            </thead>
            <tbody>
              {this.props.offices.map((item, index) => {
                if (
                  !item.name
                    .toLowerCase()
                    .includes(this.state.filterText.toLowerCase())
                ) {
                  return <></>;
                }

                return (
                  <tr key={index}>
                    <td>
                      <label>{item.name}</label>
                    </td>
                    <td>
                      <label>{item.extractionDate}</label>
                    </td>
                    <td className={"text-right"}>
                      <PrimaryArrowButton
                        size="sm"
                        onClick={() => {
                          this.props.onSelectOffice(item);
                        }}
                      >
                        Visa
                      </PrimaryArrowButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {this.props.gettingOffices && <Loader className={"p-4"} />}
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    offices: state.invoices.offices,
    gettingOffices: state.invoices.gettingOffices
  };
})(OfficeList);
